import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from '../geral/components/Header';
import MainContent from '../geral/components/MainContent';
import Footer from '../geral/components/Footer';
import QuemSomos from '../quemSomos/components/QuemSomos';
import Servicos from '../servicos/components/Servicos';
import Cursos from '../cursos/components/Cursos';
import Noticias from '../noticias/components/Noticias';
import Contatos from '../contatos/components/Contatos';
import Petshop from '../petshop/components/Petshop'
import '../geral/styles/footer.module.css'

const AppRoutes = () => {
  return (
    <Router>
      <div className="pageWrapper">
        <Header />
        <div className="content">
          <Routes>
            <Route path="/" element={<MainContent />} />
            <Route path="/QuemSomos" element={<QuemSomos />} />
            <Route path="/Servicos" element={<Servicos />} />
            <Route path="/Cursos" element={<Cursos />} />
            <Route path="/Noticias" element={<Noticias />} />
            <Route path="/Contatos" element={<Contatos />} />
            <Route path="/Petshop" element={<Petshop />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default AppRoutes;
